<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DEDICATION para-style-override-1" id="toc_marker-2">for Julian, Rosamund, Harriet and Oliver</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wright_The_Lord_and_His_Prayer_text-1.vue?37483567